import api from "../index";

// Create a constant
export const createConstant = async (values: any) => {
  return await api.post("/constant", values);
};

// Get all constants
export const getAllConstants = async () => {
  return await api.get(`/constants`);
};

// Get a constant by id
export const getConstantById = async (id: any) => {
  return await api.get(`/constant/${id}`);
};

// Update a constant by id
export const updateConstantById = async (id: any, values: any) => {
  return await api.put(`/constant/${id}`, values);
};

// Delete a constant by id
export const deleteConstantById = async (id: any) => {
  return await api.delete(`/constant/${id}`);
};
